import { css, keyframes } from "@emotion/react";

type WaveDotsLoaderProps = {
  color?: string;
  size?: number; // optional: font size (px), default 20
};

const wave = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-8px);
  }
`;

export const WaveDotsLoader = ({ color = "#555", size = 20 }: WaveDotsLoaderProps) => {
  const dotStyle = (delay: string) => css`
    display: inline-block;
    animation: ${wave} 1.2s ease-in-out infinite;
    animation-delay: ${delay};
    color: ${color};
    font-size: ${size}px;
    line-height: 1;
    margin: 0 2px;
  `;

  return (
    <div
      css={css`
        display: flex;
        align-items: flex-end;
        height: ${size + 4}px;
      `}
    >
      <span css={dotStyle("0s")}>.</span>
      <span css={dotStyle("0.2s")}>.</span>
      <span css={dotStyle("0.4s")}>.</span>
    </div>
  );
};
